import i18n from "@/i18n";

const AddressTypes = [
  {
    id: "BILLING",
    name: i18n.t("integrations.address.type.billing")
  },
  {
    id: "SHIPPING",
    name: i18n.t("integrations.address.type.shipping")
  },
  {
    id: "WAREHOUSE",
    name: i18n.t("integrations.address.type.warehouse")
  },
  {
    id: "DEFAULT_BILLING",
    name: i18n.t("integrations.address.type.default_billing")
  },
  {
    id: "DEFAULT_SHIPPING",
    name: i18n.t("integrations.address.type.default_shipping")
  },
  {
    id: "DEFAULT_WAREHOUSE",
    name: i18n.t("integrations.address.type.default_warehouse")
  },
  {
    id: "PRIMARY",
    name: i18n.t("integrations.address.type.primary")
  }
];

const CompanyAddressAttributeKeys = [
  { id: "externalId", name: "External ID" },
  { id: "customerNo", name: "External Customer Number" },
  { id: "departmentEmail", name: "Department Email" },
  { id: "billingPo", name: "Billing PO" },
  { id: "billingCustomerNo", name: "Billing Customer Number" },
  { id: "ccEmail", name: "CC Email" },
  { id: "positionNumberRequired", name: "Clarios CostCenter - Positionnumber required" },
  { id: "inventoryBlockingStrategy", name: "Inventory Blocking Strategy" }
];

export { AddressTypes, CompanyAddressAttributeKeys };
